var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-integrarion-container--wrapper"
  }, [_vm._m(0), _c('v-autocomplete', {
    attrs: {
      "items": _vm.items,
      "item-text": "name",
      "item-value": "id",
      "label": "Select a spreadsheet",
      "outlined": "",
      "dense": "",
      "required": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" No spreadsheets found ")])], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }), _c('CommonMode', {
    attrs: {
      "type": _vm.type,
      "integration": _vm.integration
    },
    on: {
      "save-info": _vm.saveInfo
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h5', {
    staticClass: "form-integrarion-text"
  }, [_vm._v(" Spreadsheets name "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])]);
}]

export { render, staticRenderFns }